import React from "react";
import { Phone, ArrowRight, MessageCircle } from "lucide-react";
import { Button } from "./ui/button";

export const Hero = ({ onOpenEstimateModal }) => {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden py-16"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1668120089662-42642838cfef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxsYW5kc2NhcGluZ3xlbnwwfHx8fDE3NzM0NTU5NzF8MA&ixlib=rb-4.1.0&q=85"
          alt="Professional Landscaping"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70" />
      </div>

      <div className="container mx-auto px-4 z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex justify-center mb-6 md:mb-8">
            <img
              src="/img/LogoSF.png"
              alt="Samaniega's Landscaping"
              className="h-28 sm:h-32 md:h-40 lg:h-56 w-auto drop-shadow-[0_12px_30px_rgba(0,0,0,0.7)]"
            />
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight">
            Professional Landscaping Services for{" "}
            <span className="text-green-400">Residential & Commercial</span>{" "}
            Properties
          </h1>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-6 md:mb-8">
            <Button
              type="button"
              onClick={onOpenEstimateModal}
              size="lg"
              className="bg-green-500 hover:bg-green-600 text-black font-bold text-sm sm:text-base md:text-lg px-6 sm:px-8 py-4 sm:py-5 md:py-6 group"
            >
              Get a Free Estimate
              <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5 group-hover:translate-x-1 transition-transform" />
            </Button>

            <Button
              asChild
              size="lg"
              variant="outline"
              className="bg-white/10 backdrop-blur-sm border-white text-white hover:bg-white hover:text-black font-bold text-sm sm:text-base md:text-lg px-6 sm:px-8 py-4 sm:py-5 md:py-6"
            >
              <a href="tel:2067080084" className="flex items-center">
                <Phone className="mr-2 h-4 w-4 sm:h-5 sm:w-5" />
                Call Now
              </a>
            </Button>
          </div>

          <div className="inline-flex items-center justify-center border-2 border-green-400 rounded-full px-5 sm:px-6 py-2.5 sm:py-3 transition-all hover:bg-green-400/10 hover:scale-105">
            <a
              href="https://wa.me/12067080084?text=Hello,%20I%20am%20interested%20in%20your%20landscaping%20services%20and%20would%20like%20to%20get%20a%20free%20estimate.%20When%20would%20be%20a%20good%20time%20to%20schedule?"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm sm:text-base md:text-lg font-bold text-green-400"
            >
              <MessageCircle className="w-4 h-4 sm:w-5 sm:h-5" />
              WhatsApp
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 md:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-5 h-9 md:w-6 md:h-10 border-2 border-white rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-white rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
